import script from "./DeliverIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./DeliverIndex.vue?vue&type=script&setup=true&lang=js"

import "./DeliverIndex.vue?vue&type=style&index=0&id=bd527c7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd527c7a"]])

export default __exports__